/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 契約ガス設備情報
 */
export interface Szma301aResCtrGasfacilityInfoDto {
    /**
     * 業種（大分類）
     */
    gyoshuLargebunrui?: string;
    /**
     * 業種（大分類）名称
     */
    gyoshuLargebunruiAname?: string;
    /**
     * 業種（中分類）
     */
    gyoshuMediumbunrui?: string;
    /**
     * 業種（中分類）名称
     */
    gyoshuMediumbunruiAname?: string;
    /**
     * 業種（小分類）
     */
    gyoshuSmallbunrui?: string;
    /**
     * 業種（小分類）名称
     */
    gyoshuSmallbunruiAname?: string;
    /**
     * メータ能力
     */
    meterAbility?: number;
    /**
     * 負荷計測器有無フラグ
     */
    fkkiEonflg?: string;
    /**
     * 負荷計測器有無フラグ名称
     */
    fkkiEonflgAname?: string;
    /**
     * 負荷計測器番号
     */
    fkkiNo?: string;
    /**
     * 負荷検読必要可否コード
     */
    fukakendokuNecessityflag?: string;
    /**
     * 負荷検読必要可否コード名称
     */
    fukakendokuNecessityflagAname?: string;
    /**
     * 動作モード
     */
    operatingmode?: string;
}

